var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentsISupervise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.69 147.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.69,323.54V431.63H268.33c.45,3.36.86,6.42,1.33,9.86H152.49c-5.29,0-6.77-1.46-6.77-6.7V320.28c0-5.27,1.51-6.8,6.72-6.8H311.11c5.08,0,6.65,1.53,6.65,6.59q0,35.24,0,70.46c0,.84-.09,1.67-.15,2.73L308,392.1V323.54Z",
    transform: "translate(-145.72 -313.48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.78,377.49c-13.06-6.38-17.77-14-15.13-24.58A19.67,19.67,0,0,1,224,354.07c2.05,10.21-3.14,18-15.74,23.49,7.58,1,14.37,3.39,20.21,8a63.08,63.08,0,0,1,5.8,5.42c3.44,3.52,5.42,7.49,4.86,12.72-.46,4.2-.1,8.49-.1,12.95H170.39c0-.82-.13-1.72-.14-2.62,0-3.69.27-7.41-.08-11.07-.41-4.34,1.26-7.64,3.89-10.82C180.67,384.17,187.63,380.27,200.78,377.49Z",
    transform: "translate(-145.72 -313.48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.57,429.22a31.92,31.92,0,1,1,31.9,32A32,32,0,0,1,273.57,429.22Zm31.27,13.89L327.18,421l-5.47-5.52L304.6,432.6l-10.45-11.25-5.79,5.31C294,432.32,299.5,437.78,304.84,443.11Z",
    transform: "translate(-145.72 -313.48)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.17,357.62v-4.78h40c4.57,0,4.57,0,3.79,4.78Z",
    transform: "translate(-145.72 -313.48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288,372.49H244.28v-4.88h40.18C288.76,367.62,288.76,367.62,288,372.49Z",
    transform: "translate(-145.72 -313.48)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.26,382.37h40c4.53,0,4.53,0,3.8,4.8H244.26Z",
    transform: "translate(-145.72 -313.48)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.74,397.52v4.36H244.28v-4.36Z",
    transform: "translate(-145.72 -313.48)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsISupervise);
export default __webpack_public_path__ + "static/media/students_i_supervise.614796d941d25d27c9e74e7e8944eed0.svg";
export { ForwardRef as ReactComponent };